/* ============================================================
   ODM MERCH — SHOPIFY THEME JS
   Operator Down Medical | THE AGENCY PG LLC
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ─── Mobile Menu ───────────────────────────────────────────
  const menuToggle = document.getElementById('menu-toggle');
  const mobileNav  = document.getElementById('mobile-nav');

  menuToggle?.addEventListener('click', () => {
    const isOpen = mobileNav.classList.toggle('is-open');
    menuToggle.setAttribute('aria-expanded', isOpen);
    mobileNav.setAttribute('aria-hidden', !isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  // Close mobile nav on link click
  document.querySelectorAll('.mobile-nav__link').forEach(link => {
    link.addEventListener('click', () => {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  // ─── Cart Drawer ───────────────────────────────────────────
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartToggle  = document.getElementById('cart-toggle');
  const cartClose   = document.querySelector('.cart-drawer__close');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');

  function openCartDrawer() {
    cartDrawer?.classList.add('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }
  window.openCartDrawer = openCartDrawer;

  function closeCartDrawer() {
    cartDrawer?.classList.remove('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartToggle?.addEventListener('click', openCartDrawer);
  cartClose?.addEventListener('click', closeCartDrawer);
  cartOverlay?.addEventListener('click', closeCartDrawer);

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        renderCartDrawerItems(cart);
        const totalEl = document.getElementById('cart-drawer-total');
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      })
      .catch(console.error);
  }

  function renderCartDrawerItems(cart) {
    const body = document.getElementById('cart-drawer-body');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div style="text-align:center;padding:3rem 1rem;">
          <p style="font-family:var(--font-heading);font-size:0.9rem;letter-spacing:0.2em;color:var(--grey-500);text-transform:uppercase;margin-bottom:1.5rem;">YOUR KIT IS EMPTY</p>
          <a href="/collections/all" class="btn btn--red">GEAR UP</a>
        </div>`;
      return;
    }

    body.innerHTML = cart.items.map(item => `
      <div class="cart-item" style="grid-template-columns:80px 1fr;gap:1rem;">
        <a href="${item.url}" style="display:block;aspect-ratio:1;background:var(--grey-200);border-radius:2px;overflow:hidden;">
          <img src="${item.image}" alt="${item.title}" style="width:100%;height:100%;object-fit:cover;">
        </a>
        <div>
          <h4 style="font-family:var(--font-heading);font-size:0.85rem;letter-spacing:0.05em;text-transform:uppercase;margin-bottom:0.25rem;">${item.product_title}</h4>
          ${item.variant_title !== 'Default Title' ? `<p style="font-size:0.8rem;color:var(--grey-500);margin-bottom:0.5rem;">${item.variant_title}</p>` : ''}
          <div style="display:flex;justify-content:space-between;align-items:center;">
            <span style="font-family:var(--font-heading);font-size:0.9rem;">Qty: ${item.quantity}</span>
            <span style="font-family:var(--font-heading);font-size:0.9rem;">${formatMoney(item.final_line_price)}</span>
          </div>
        </div>
      </div>`
    ).join('');
  }

  // ─── Update Cart Count Badge ────────────────────────────────
  function updateCartCount(count) {
    document.querySelectorAll('#cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // ─── Add to Cart (Product Cards) ───────────────────────────
  document.querySelectorAll('[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      const originalText = btn.textContent;
      btn.textContent = 'ADDING...';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!res.ok) throw new Error('Failed to add');
        btn.textContent = 'ADDED ✓';
        setTimeout(() => openCartDrawer(), 200);
      } catch (err) {
        console.error(err);
        btn.textContent = 'TRY AGAIN';
      } finally {
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      }
    });
  });

  // ─── Sticky Header Shadow ───────────────────────────────────
  const header = document.getElementById('site-header');
  window.addEventListener('scroll', () => {
    if (header) {
      header.style.boxShadow = window.scrollY > 20
        ? '0 4px 24px rgba(0,0,0,0.5)'
        : 'none';
    }
  }, { passive: true });

  // ─── Money Formatter ────────────────────────────────────────
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ─── Fade-in on Scroll ──────────────────────────────────────
  const fadeEls = document.querySelectorAll('.product-card, .section-header, .mission-strip__item');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  fadeEls.forEach((el, i) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = `opacity 0.5s ease ${i * 0.05}s, transform 0.5s ease ${i * 0.05}s`;
    observer.observe(el);
  });

});
